import { ChartOfAccount } from "./chart-of-account";
import { GeneralLedger } from "./general-ledger";
import { SystemField } from "./system-field";

export class GeneralLedgerDetail extends SystemField { 
     coa_id?:string;
     sub_coa_id?:string;
     credit_amount?:number;
     debit_amount?:number;
     transaction_type?:string;
     ref_number?:string;
     comments?:string;
     general_ledger_id?:string;

     //relationship
     general_ledger?:GeneralLedger;
     chart_of_account?:ChartOfAccount;
     sub_chart_of_account?:ChartOfAccount;
     
}
